import React from 'react';
import { trans } from '@spotahome/soyuz/client';

import SelectImage from '../../../common/components/icons/SelectImage';
import ReserveImage from '../../../common/components/icons/ReserveImage';
import ConfirmationImage from '../../../common/components/icons/ConfirmationImage';
import MoveInImage from '../../../common/components/icons/MoveInImage';

import './HiwContent.scss';

const HiwContent = () => (
  <div className="hiw-wrapper">
    <div className="hiw-container">
      <SelectImage className="hiw-container__image" />
      <div className="hiw-container__section-wrapper">
        <span className="hiw-container__number">1</span>
        <h3 className="hiw-container__title">
          {trans('how_it_works.alt.step1.title')}
        </h3>
        <div>
          <p className="hiw-container__main-text">
            {trans('how_it_works.alt.step1.text')}
          </p>

          <div className="hiw-container__block-wrapper">
            <div className="hiw-container__info-wrapper hiw-container__info-wrapper--mr">
              <h4 className="hiw-container__underlined-title">
                {trans('how_it_works.alt.step1.block1.title')}
              </h4>
              <p className="hiw-container__block-text">
                {trans('how_it_works.alt.step1.block1.text')}
              </p>
            </div>
            <div className="hiw-container__info-wrapper">
              <h4 className="hiw-container__underlined-title">
                {trans('how_it_works.alt.step1.block2.title')}
              </h4>
              <p className="hiw-container__block-text">
                {trans('how_it_works.alt.step1.block2.text')}
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div className="hiw-container">
      <ReserveImage className="hiw-container__image" />
      <div className="hiw-container__section-wrapper">
        <span className="hiw-container__number">2</span>
        <h3 className="hiw-container__title">
          {trans('how_it_works.alt.step2.title')}
        </h3>
        <div>
          <p className="hiw-container__main-text">
            {trans('how_it_works.alt.step2.text')}
          </p>

          <div className="hiw-container__block-wrapper">
            <div className="hiw-container__info-wrapper">
              <h4 className="hiw-container__underlined-title hiw-container__underlined-title--full">
                {trans('how_it_works.alt.step2.block1.title')}
              </h4>
              <div className="hiw-container__divided">
                <p className="hiw-container__block-text">
                  <strong>
                    {trans('how_it_works.alt.step2.block1.text1.strong')}
                  </strong>{' '}
                  {trans('how_it_works.alt.step2.block1.text1')}
                </p>
                <p className="hiw-container__block-text">
                  <strong>
                    {trans('how_it_works.alt.step2.block2.text2.strong')}
                  </strong>{' '}
                  {trans('how_it_works.alt.step2.block2.text2')}
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div className="hiw-container">
      <ConfirmationImage className="hiw-container__image" />
      <div className="hiw-container__section-wrapper hiw-container__section-wrapper--more-pb">
        <span className="hiw-container__number">3</span>
        <h3 className="hiw-container__title">
          {trans('how_it_works.alt.step3.title')}
        </h3>
        <div>
          <p className="hiw-container__main-text">
            {trans('how_it_works.alt.step3.text')}
          </p>

          <div className="hiw-container__block-wrapper">
            <div className="hiw-container__info-wrapper--mr">
              <h4 className="hiw-container__underlined-title">
                {trans('how_it_works.alt.step3.block1.title')}
              </h4>
              <p className="hiw-container__block-text hiw-container__block-text--step3">
                {trans('how_it_works.alt.step3.block1.text')}
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div className="hiw-container hiw-container--last">
      <MoveInImage className="hiw-container__image" />
      <div className="hiw-container__section-wrapper hiw-container__section-wrapper--last">
        <span className="hiw-container__number hiw-container__number--gray-bg">
          4
        </span>
        <h3 className="hiw-container__title">
          {trans('how_it_works.alt.step4.title')}
        </h3>
        <p className="hiw-container__main-text mb-halve">
          {trans('how_it_works.alt.step4.text1')}
        </p>
        <p className="hiw-container__main-text">
          {trans('how_it_works.alt.step4.text2')}
        </p>

        <div className="hiw-container__block-wrapper hiw-container__block-wrapper--step4">
          <div className="hiw-container__info-wrapper">
            <h4 className="hiw-container__underlined-title">
              {trans('how_it_works.alt.step4.block1.title')}
            </h4>
            <p className="hiw-container__block-text">
              {trans('how_it_works.alt.step4.block1.text')}
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
);

export default HiwContent;
